<template lang="pug">
  v-flex.fill-height(style="width: 200px")
    v-overflow-btn.mt-0.fill-height(:items='menu_a_imprimir' label='Opciones' segmented :loading="estado_del_documento=='procesando'" )
    
 
</template>
<script>
import {mapActions} from 'vuex'
export default {
  data: vm => ({
    menu_original: [
     
      { text: 'Generar Salida', callback: () => vm.generar_ventas(vm.id), estado_de_visibilidad: ['esperando', 'procesado']},
      { text: 'Editar', callback: () => vm.editar_ventas(vm.id), estado_de_visibilidad: ['esperando']},
      { text: 'Ver', callback: () => vm.editar_ventas(vm.id), estado_de_visibilidad: ['procesado', 'emitido'] },
      { text: 'Descargar Comprobante', callback: () => window.open(vm.link), estado_de_visibilidad: ['emitido'] },
    ],
    menu_a_imprimir: []
  }),

  props:{
    estado_del_documento: String,
    id: String,
    message: String,
    link: String
  },
  watch: {
    'estado_del_documento'(){
      this.filtrar_menu()
    }
  },
  created(){
    this.filtrar_menu()
  },
  methods: {
    ...mapActions({
      unProcess: 'Sales/unProcess',
      generar_ventas: 'Sales/generar_ventas',
      editar_ventas: 'Sales/get',
    }),
    filtrar_menu(){
      this.menu_a_imprimir = this.menu_original.filter(item => item.estado_de_visibilidad.indexOf(this.estado_del_documento) > -1)
    }
  }
}
</script>
<style lang='sass'>
  .v-overflow-btn
    .v-input__control
      height: 100%
      &:before
        height: 0px
    .v-input__slot
      height: 100%
      margin-bottom: 0
      &:before
        width: 0px!important
    .v-select__slot
      height: 100%
    .v-select__selections
      height: 100%
    .v-btn
      height: 100%!important

</style>
